import { render, staticRenderFns } from "./MeetYou.vue?vue&type=template&id=479e1160&scoped=true&"
import script from "./MeetYou.vue?vue&type=script&lang=ts&"
export * from "./MeetYou.vue?vue&type=script&lang=ts&"
import style0 from "./MeetYou.vue?vue&type=style&index=0&id=479e1160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479e1160",
  null
  
)

export default component.exports